import { useState } from "react";
import { faqList } from "@/mocks/anime";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div>
            <span className="text-xs font-medium text-primary-600">常见问题</span>
            <h2 className="mt-1 text-xl font-bold text-foreground-950 md:text-2xl">
              关于追番，你想知道的都在这
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              关于更新频率、观看方式、追番日历的使用等常见疑问，妖精动漫网为你一一解答。
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="space-y-3">
              {faqList.map((item, index) => {
                const isOpen = open === index;
                return (
                  <div
                    key={item.q}
                    className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : index)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="text-sm font-bold text-foreground-950">{item.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-transform ${
                          isOpen ? "rotate-180" : ""
                        }`}
                      >
                        <i className="ri-arrow-down-s-line text-base"></i>
                      </span>
                    </button>
                    {isOpen && (
                      <p className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-700">
                        {item.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}